import { Currency } from "../utils/currencyToSymbolMapper"
import { AxiosService } from "./AxiosService"

type CustomerSession = {
    secret: string
}
export type SubscriptionInterval = 'YEARLY' | 'MONTHLY' | 'WEEKLY' | 'UNLIMITED' | 'LIMITED'
export type OrganizationSubscriptionInterval = | 'UNLIMITED' | 'LIMITED'
export type SubscriptionStatus = 'ACTIVE' | 'CANCELLED'

export type SubscriptionInfo = {
    id: string
    name: string
    networkName: string
    status: SubscriptionStatus
    interval: SubscriptionInterval
    renewal?: number
    connection?: { name: string }
}

type OrganizationSubscriptionInfo = {
    id: string
    name: string
    networkName: string
    interval: OrganizationSubscriptionInterval
    renewal?: number
    connection?: { name: string }
}

export type AdminSubscriptionInfo = SubscriptionInfo & {
    ownerId: string
    ownerEmail: string
}

export type SubscriptionOverview = {
    tokenAmount: number,
    subscriptions: SubscriptionInfo[]
    subscriptionLimit: number
}

export type OrganizationOverview = {
    subscriptions: OrganizationSubscriptionInfo[]
    subscriptionLimit?: number
}

export type PricingTableProduct = {
    name: string
    priceId: string
    amount: number
    currency: Currency
    bestChoice?: boolean
    attributes?: []
    testMode: boolean
    interval: 'YEARLY' | 'MONTHLY' | 'WEEKLY'
}


export type PricingTable = {
    name: string
    data: PricingTableProduct[]
}

export const SubscriptionService = new (class {
    getCustomerSession(userToken: string): Promise<CustomerSession> {
        return AxiosService.getAuth(`${process.env.REACT_APP_MIDDLEWARE_ENDPOINT}/getCustomerSecret`, userToken)
    }

    getSubscriptions(userToken: string): Promise<SubscriptionOverview> {
        return AxiosService.getAuth(`${process.env.REACT_APP_MIDDLEWARE_ENDPOINT}/subscriptions`, userToken)
    }

    getPricingTables(): Promise<PricingTable[]> {
        return AxiosService.get(`${process.env.REACT_APP_MIDDLEWARE_ENDPOINT}/stripe/subscription-pricing-tables`)
    }

    cancel(userToken: string, subscriptionId: string): Promise<void> {
        return AxiosService.putAuth(`${process.env.REACT_APP_MIDDLEWARE_ENDPOINT}/subscriptions/cancel`, userToken, { subscriptionId })
    }

    resume(userToken: string, subscriptionId: string): Promise<void> {
        return AxiosService.putAuth(`${process.env.REACT_APP_MIDDLEWARE_ENDPOINT}/subscriptions/resume`, userToken, { subscriptionId })
    }
})()


export const OrganizationSubscriptionService = new (class {
    getSubscriptions(userToken: string, organizationUrl: string): Promise<{ type: 'Member', subscriptions: OrganizationSubscriptionInfo[] } | {
        type: 'Admin', subscriptions: (OrganizationSubscriptionInfo & {
            ownerId: string
            ownerEmail: string
        })[], subscriptionLimit: number
    }> {
        return AxiosService.getAuth(`${process.env.REACT_APP_MIDDLEWARE_ENDPOINT}/org/${organizationUrl}/subscriptions`, userToken)
    }
})()


export const OrganizationAdminSubscriptionService = new (class {
    deleteSubscription(userToken: string, organizationUrl: string, subscriptionId: string): Promise<void> {
        return AxiosService.deleteAuth(`${process.env.REACT_APP_MIDDLEWARE_ENDPOINT}/org/${organizationUrl}/subscriptions`, userToken, { subscriptionId })
    }
})()

export const AdminSubscriptionService = new (class {
    getSubscriptions(userToken: string): Promise<(AdminSubscriptionInfo)[]> {
        return AxiosService.getAuth(`${process.env.REACT_APP_MIDDLEWARE_ENDPOINT}/admin/subscriptions`, userToken)
    }

    deleteSubscription(userToken: string, subscriptionId: string): Promise<void> {
        return AxiosService.deleteAuth(`${process.env.REACT_APP_MIDDLEWARE_ENDPOINT}/admin/subscriptions`, userToken, { subscriptionId })
    }

    cancel(userToken: string, subscriptionId: string): Promise<void> {
        return AxiosService.putAuth(`${process.env.REACT_APP_MIDDLEWARE_ENDPOINT}/admin/subscriptions/cancel`, userToken, { subscriptionId })
    }

    resume(userToken: string, subscriptionId: string): Promise<void> {
        return AxiosService.putAuth(`${process.env.REACT_APP_MIDDLEWARE_ENDPOINT}/admin/subscriptions/resume`, userToken, { subscriptionId })
    }
})()
